import React from 'react';
import moment from "moment";

export default initialState => WrappedComponent => class extends React.Component {
 state = initialState;

  handleChange = name => value => {
    if (moment.isMoment(value)) {
      this.setState({[name]: value.format('DD/MM/YYYY')});
    } else if(typeof value === 'object' && value.hasOwnProperty('target')){
      this.setState({[name]: value.target.value});
    } else {
      this.setState({[name]: value});
    }
  };

  handleClearFilters = callback => () => {
    this.setState(initialState, callback);
  };

  render() {
    return (
      <WrappedComponent
        {...this.props}
        fields={{...this.state}}
        handleChange={this.handleChange}
        handleClearFilters={this.handleClearFilters}
      />
    );
  };
}


// WEBPACK FOOTER //
// ./src/components/withInputChange.jsx